import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', 'Notifications/System')
export const DATA_UPDATE_REQUEST_ASYNC = createAsyncTypes(
  'DATA_UPDATE_REQUEST',
  'Notifications/System'
)

export const FREQUENCY_OPTIONS_CONST = [
  { value: 0, label: 'Daily' },
  { value: 1, label: 'Weekly' },
  { value: 2, label: 'Monthly' },
  { value: 3, label: 'Quarterly' },
]

export const VERIFY_DOMAIN_ASYNC = createAsyncTypes('VERIFY_DOMAIN_ASYNC', 'Notifications/System')

export const customDomainKBLink =
  'https://support.ironscales.com/hc/en-us/articles/4415431655324-Changing-Email-Address-of-System-Alerts'
export const simAndTrainKBLink =
  'https://support.ironscales.com/hc/en-us/articles/360019129251-Simulation-Training-Settings'

export const POLICY_MANAGED_FEATURES = {
  EMAIL_ALERTS: 'email_alerts',
  IDENTIFIER_PREFIX: 'identifier_prefix',
}
